import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment, useRef, useCallback} from 'react';
import { useNavigate,useParams,useLocation } from "react-router-dom";
import apiRequest from '../../functions/api';
import { TextField,Grid,Typography, CardContent,Card,Button,Box} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import SaveIcon from '@mui/icons-material/Save';
import { useMessage } from '../../context/message-context';
import {DateTextField, Mitarbeiterauswahl,Zeitraum,} from '../lib';
import Autocomplete from '@mui/material/Autocomplete';
import openFile from "../shared/functions/download";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import {FullPageSpinner} from '../lib';
function Interview(props) {
  const { t } = useTranslation();
  let { interview } = useParams();
  const navigate = useNavigate();
  const location= useLocation();
  const [interviewbez,setInterviewBez] = useState(interview);
  const [speicherbutton,setSpeicherButton] = useState("Interview beenden");
  const [avar,setAvar] = useState([]);
  const { accessToken,  client} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [gezeichnet,setGezeichnet] = useState([]);
  const [routinestart,setRoutineStart]=useState("");
  const {hideMessage, showErrorMessage} = useMessage();
  const [ablauf,setAblauf]=useState([]);
  const [letztefrage,setLetzteFrage]=useState("");
  const [letztenr,setLetzteNr]=useState("");
  const [aktinterview,setAktInterview]=useState(interview.toLowerCase());
  const [fehler,setFehler]=useState(false);
  const [aktbedingung,setAktBedingung]=useState([]);
  const [ablaufnext,setAblaufNext]=useState("");
  const [antwort,setAntwort]=useState({});
  const janein=[{tbl:"J",vorgabe:t("Ja")},{tbl:"N",vorgabe:t("Nein")}];
  const [selectedFile, setSelectedFile] = useState([]);
  const refabgang = useRef("");
  const refbedingung_iv = useRef("");
  const refbedingung_bez = useRef("");
  const refbedingung_art = useRef("");
  const refbedingung_antwort = useRef("");
  const refbedingung_auswahl = useRef("");
  const refbedingung_ausblenden = useRef("");
  const refbedingung_antwort_ueber = useRef("");
  const refbedingung_datei = useRef("");
  const refbedingung_fehler = useRef("");
  const refbedingung_pflicht = useRef("");
  const refbedingung_disabled = useRef("")
  const neuzeichnen = useRef(0);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const programm=location?.state?.programm ? location?.state.programm : interview;
  const austritt=location?.state?.austritt ? location?.state.austritt : interview;
  const uebergaben=location?.state?.uebergaben ? location?.state?.uebergaben : [];
  const mobilheight=useRef(window.innerHeight);
  const desktopheight=useRef(window.innerHeight/10);
  const [showModal, setShowModal] = useState(false);
  const [drucken,setDrucken]=useState("");
  const [datname,setDatName]=useState("");
  const [workflowuebergaben,setWorkflowUebergaben] = useState(uebergaben);
  const [laden,setLaden] = useState(false);
  const [gleichefrage,setGleicheFrage]=useState(false);
  useEffect(() => {
    setAblaufNext("");
    setIsLoading(true);
    HoleInterviewFragen();
    // eslint-disable-next-line
  }, [interview])
 
  useEffect(() => {
    if (gezeichnet.length>0 && neuzeichnen.current===1 ) {
      neuzeichnen.current=0
      if (gezeichnet[gezeichnet.length-1].ausblenden==="1" && gezeichnet[gezeichnet.length-1].art!=="ERGEBNIS") {
        naechste_frage(gezeichnet.length-1,gezeichnet[gezeichnet.length-1].key,gezeichnet[gezeichnet.length-1].antwort,gezeichnet[gezeichnet.length-1].iv)
        return
      };
      if ((gezeichnet[gezeichnet.length-1].antwort_ueber==="1" ||  gezeichnet[gezeichnet.length-1].disabled==="1") && gezeichnet[gezeichnet.length-1].ausblenden!=="1" ) {     
        naechste_frage(gezeichnet.length-1,gezeichnet[gezeichnet.length-1].key,gezeichnet[gezeichnet.length-1].antwort,gezeichnet[gezeichnet.length-1].iv)
        return
      };
     
      if (gezeichnet[gezeichnet.length-1].art==="TITEL" && gezeichnet[gezeichnet.length-1].ausblenden!=="1" && gezeichnet[gezeichnet.length-1].antwort_ueber!=="1" ) {
        naechste_frage(gezeichnet.length-1,gezeichnet[gezeichnet.length-1].key,gezeichnet[gezeichnet.length-1].antwort,gezeichnet[gezeichnet.length-1].iv)
        return
      };
      
      if (gezeichnet[gezeichnet.length-1].art==="HINWEIS" && gezeichnet[gezeichnet.length-1].ausblenden!=="1" && gezeichnet[gezeichnet.length-1].antwort_ueber!=="1" ) {
        naechste_frage(gezeichnet.length-1,gezeichnet[gezeichnet.length-1].key,gezeichnet[gezeichnet.length-1].antwort,gezeichnet[gezeichnet.length-1].iv)
        return
      };
    }
    
    //eslint-disable-next-line
  }, [gezeichnet])
  useEffect(() => {
    if (gezeichnet.length>0) {
      ermittle_naechste_frage()
    }
    //eslint-disable-next-line
  }, [ablaufnext,gleichefrage])
  const erneut=()=> {
    ermittle_naechste_frage()
  }
  const closeModal = () => {
    setShowModal(false);
  }
  async function bedingung (frage,anzahlfrage,bedingungsart,akt_interview,daten) {
    setLaden(true);
    var temp_frage=frage;
    var temp_anzahlfrage=anzahlfrage;
    var temp_bedingungsart=bedingungsart;
    var temp_akt_interview=akt_interview
    if (frage!=="") {
      setAktBedingung({"frage":frage,"anzahlfrage":anzahlfrage,"bedingungsart":bedingungsart,"akt_interview":akt_interview,});
    }
    if (frage==="") {    
      temp_frage=aktbedingung.frage
      temp_anzahlfrage=aktbedingung.anzahlfrage
      temp_bedingungsart=aktbedingung.bedingungsart
      temp_akt_interview=aktbedingung.akt_interview
    }
    var payload={}
    if (bedingungsart==="nach") {
      payload={
        "mandant": client,
        "program":programm,
        "statement": "INTERVIEW_BEDINGUNG",
        "interview": temp_akt_interview,
        "fragen":daten,
        "avar":temp_frage.var,
        "anzahlfragen":temp_anzahlfrage+1,
        "bedingungsart":temp_bedingungsart,
        "orig_interview":interview,
        "art":temp_frage.art,
        "eingabe_art":temp_frage.eingabeart,
        "files":selectedFile?.name,
        "uebergaben":workflowuebergaben,
      }      
    } else {
       payload={
        "mandant": client,
        "program":programm,
        "statement": "INTERVIEW_BEDINGUNG",
        "interview": temp_akt_interview,
        "fragen":gezeichnet,
        "avar":temp_frage.var,
        "anzahlfragen":temp_anzahlfrage+1,
        "bedingungsart":temp_bedingungsart,
        "orig_interview":interview,
        "art":temp_frage.art,
        "eingabe_art":temp_frage.eingabeart,
        "files":selectedFile?.name,
        "uebergaben":workflowuebergaben,
      }
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    await apiRequest('POST', 'interview', payload, headers, bedingungCb,errorCb);
  }
  
  const speicher_interview = () => {
    setShowModal(true)
     if (drucken==="1" || drucken==="ZUSATZ") {
       interview_drucken();
     } else {
       interview_ende();
     }
  }
  
  const interview_drucken = () => {
    const payload={
      "interview":interview,
      "fragen":gezeichnet,
      "avar":avar,
      "anzahlfragen":gezeichnet.length,
      "drucken":drucken,
      "uebergaben":workflowuebergaben,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
      "Mandant": client,
      "Program":programm,
    }
    axios.post(API_BASE_URL+'interview-ende', payload, {headers: headers, responseType: 'blob'})
    
    .then((response) => {
      var fileName = datname;
      var contentFile = response.data;
      const mimeType = response.headers['content-type'] || 'application/pdf'
      openFile(fileName, contentFile, mimeType);
      closeModal();
      navigate(-1);  
    })
    .catch(function (error) {
      closeModal();
      showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
    });
  }
  const interview_ende = () => {
    const payload={
      "interview":interview,
      "fragen":gezeichnet,
      "avar":avar,
      "anzahlfragen":gezeichnet.length,
      "uebergaben":workflowuebergaben,
    }
    const data = new FormData();
    hideMessage();
    for (let index = 0; index < selectedFile.length; index++) {
      data.append('file', selectedFile[index]);
    }
    data.append('payload', JSON.stringify(payload));
    const headers={
      "Authorization": "Bearer "+accessToken,
      "Mandant": client,
      "Program":programm,
    }
    apiRequest('POST', 'interview-ende', data, headers, endeCb);
  }
  const endeCb = (response) => {
    setShowModal(false);
    if (response.status === 200) {
        hideMessage();
        navigate(-1); 
        showSuccessMessage(response.data.message);
      } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
  const bedingungCb = (response) => {
    setLaden(false);
    refabgang.current="";
    refbedingung_bez.current="";
    refbedingung_art.current=""
    refbedingung_antwort.current="";
    refbedingung_auswahl.current="";
    refbedingung_ausblenden.current="";
    refbedingung_antwort_ueber.current="";
    refbedingung_datei.current="";
    refbedingung_fehler.current="";
    refbedingung_iv.current="";
    refbedingung_disabled.current=""
    refbedingung_pflicht.current=""; 
    if (response.status === 200) {
        if (response.data.abgang) {
          refabgang.current=response.data.abgang;
        };
        if (response.data.bedingung_bez) {
          refbedingung_bez.current=response.data.bedingung_bez;
        };
        if (response.data.bedingung_art) {
          refbedingung_art.current=response.data.bedingung_art;
        };
        if (response.data.bedingung_antwort) {
          refbedingung_antwort.current=response.data.bedingung_antwort;
        };
        if (response.data.bedingung_auswahl) {
          refbedingung_auswahl.current=response.data.bedingung_auswahl;
        };
        if (response.data.ausblenden) {
          refbedingung_ausblenden.current=response.data.ausblenden;
        };
        if (response.data.ueber) {
          refbedingung_antwort_ueber.current=response.data.ueber;
        };
        if (response.data.datei) {
          refbedingung_datei.current=response.data.datei;
        };
        if (response.data.disabled) {
          refbedingung_disabled.current=response.data.disabled;
        };
        if (response.data.pflicht) {
          refbedingung_pflicht.current=response.data.pflicht;
        };
        if (response.data.drucken) {
          setDrucken(response.data.drucken);
        };
        if (response.data.datname) {
          setDatName(response.data.datname);
        };
        if (response.data.uebergaben) {
          setWorkflowUebergaben(response.data.uebergaben);
        }
        if (response.data.interview) {
        //  navigate("/interview/"+response.data.interview,{state: { programm: programm }})
          refbedingung_iv.current=response.data.interview
          setFehler(false)
          return
        };
        setIsLoading(false) 
        setFehler(false)
      } else {
        setIsLoading(false) 
        if (response.data && response.data.fehler) {
          showErrorMessage(response.data.message);
          refbedingung_fehler.current=response.data.fehler
          if (response.data.bedingung_antwort) {
            refbedingung_antwort.current=response.data.bedingung_antwort;
          }        
        } else {
          showErrorMessage(response.data.message);
          setIsLoading(false)
          setFehler(true)
        }
    }      
  }
  const HoleInterviewFragen = () => {
    setGezeichnet([]);
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program":programm,
      "statement": "INTERVIEW_START",
      "interview":interview,
      "uebergaben":workflowuebergaben,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'interview', payload, headers, fragenCb);
  }
  async function erste_frage (response) {
    var bed_antwort=""
    if(response.data.uebergaben) {
      var fragen_var=response.data[interview.toLowerCase()].fragen.F001.var
      fragen_var=fragen_var.replace("$","")
      if (response.data.uebergaben[interview.toUpperCase()]?.[fragen_var]){
        response.data[interview.toLowerCase()].fragen.F001.antwort=response.data.uebergaben[interview.toUpperCase()]?.[fragen_var]
      }
    }
    if (response.data[interview.toLowerCase()].fragen.F001.vor==="1") {
      await bedingung(response.data[interview.toLowerCase()].fragen.F001,0,"VOR",interview.toLowerCase());
      if (refbedingung_bez.current!=="") {
        response.data[interview.toLowerCase()].fragen.F001.bez=refbedingung_bez.current;
      }
      if (refbedingung_antwort.current!=="") {
        response.data[interview.toLowerCase()].fragen.F001.antwort=refbedingung_antwort.current;
      }
      if (refbedingung_art.current!=="") {
        response.data[interview.toLowerCase()].fragen.F001.art=refbedingung_art.current;
      } 
      if (refbedingung_auswahl.current!=="") {
        response.data[interview.toLowerCase()].fragen.F001.auswahl=refbedingung_auswahl.current;
      }
    }
    if (response.data[interview.toLowerCase()].fragen.F001.antwort) { bed_antwort=response.data[interview.toLowerCase()].fragen.F001.antwort }
    neuzeichnen.current=1;
    setGezeichnet([{key:"F001",art:response.data[interview.toLowerCase()].fragen.F001.art,bez:response.data[interview.toLowerCase()].fragen.F001.bez,antwort:bed_antwort,eingabeart:response.data[interview.toLowerCase()].fragen.F001.eingabeart,avar:response.data[interview.toLowerCase()].fragen.F001.var,auswahl:response.data[interview.toLowerCase()].fragen.F001.auswahl,ausblenden:refbedingung_ausblenden.current,antwort_ueber:refbedingung_antwort_ueber.current,iv:interview.toLowerCase(),datei:refbedingung_datei.current}]);  
  }
  
  const errorCb = () => {
    setLaden(false);
    setFehler(true);
  }
  const fragenCb = (response) => {
    if (response.status === 200) {
        var iv=interview.toLowerCase();
        localStorage.setItem(iv,JSON.stringify(response.data))
        setAblauf(response.data);
        setAvar(response.data[interview.toLowerCase()].avar);
        if (response.data.speicher_btn !=="") {setSpeicherButton(response.data.speicher_btn)};
        if (response.data.interv_name !=="") {setInterviewBez(response.data.interv_name)};
        if (response.data.drucken) {setDrucken(response.data.drucken)};
        if (response.data.datname) {setDatName(response.data.datname)};
        setIsLoading(false);
        hideMessage();  
        erste_frage(response);
      } else {
        if (response) {
          showErrorMessage(response.data.message);
          setIsLoading(false);
          // navigate(-1);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
  }
  
  const interview_beenden = () => {
    speicher_interview();  
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  
  const setze_eingabe_antwort = (frageid,interv,value,count) => {
    var temp_gezeichnet=gezeichnet.slice()
    var objAntwort=Object.assign(antwort)
    objAntwort[interv+frageid+count]=value;
    setAntwort(objAntwort);
    temp_gezeichnet[count].antwort=value
    setGezeichnet(temp_gezeichnet)
  }
  
  const ivbutton_click = (count,element) => {
      naechste_frage(count,element.key,element.bez,element.iv,element.letzte_nr,element.letzte_frage)
  }
  const onChangeHandler = (event,count,element) => {  
    setSelectedFile([...event.target.files]);
    naechste_frage(count,element.key,element.bez,element.iv,element.letzte_nr,element.letzte_frage)
  }
  async function ermittle_naechste_frage() {
    setGleicheFrage(false)
    refabgang.current="";
    refbedingung_bez.current="";
    refbedingung_art.current=""
    refbedingung_antwort.current="";
    refbedingung_auswahl.current="";
    refbedingung_ausblenden.current="";
    refbedingung_antwort_ueber.current="";
    refbedingung_datei.current="";
    refbedingung_pflicht.current="";
    var next=ablaufnext
    var temp_daten=gezeichnet.slice();
    var ablauf_fragen=Object.assign(ablauf);
    
    var akt_interview=aktinterview
    var frageid=next      
    var fragenr=gezeichnet.length-1
    var letzte_frage=""
    var letzte_nr=""
    var letztes_zeichen=""
    var neu_zeichen=0
    var abzug=1
    if (next!=="") {
      var temp_antwort=""
      if (ablauf_fragen[akt_interview].fragen[next].interview) {
        letzte_frage=ablauf_fragen[akt_interview].fragen[next].letzte_frage
        letzte_nr=next
        setLetzteFrage(letzte_frage)
        setLetzteNr(letzte_nr)
        setAktInterview(ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase())
        next="F001"
        setAblaufNext(next)
        return
      }
      if (ablauf_fragen[akt_interview].fragen[next].art === "ERGEBNIS") {
        if (akt_interview!==interview.toLowerCase()) {
          if (ablauf_fragen[akt_interview].fragen[next].vor==="1") {
            await bedingung(ablauf_fragen[akt_interview].fragen[next],fragenr,"VOR",ablauf_fragen[akt_interview].fragen[next].iv,);
          }
          letztes_zeichen=letztenr.substr(letztenr.length-3,3);
          neu_zeichen=Number(letztes_zeichen);
          neu_zeichen=neu_zeichen+1;
          if (neu_zeichen>9) {abzug=2 }
          if (neu_zeichen>99) {abzug=3 }
          next=letztenr.substr(0,letztenr.length-abzug)+neu_zeichen;
          akt_interview=interview.toLowerCase()
          if (ablauf_fragen[akt_interview].fragen[next].interview) {
            letzte_frage=ablauf_fragen[akt_interview].fragen[next].letzte_frage
            letzte_nr=next
            setLetzteFrage(letzte_frage)
            setLetzteNr(letzte_nr)
            setAktInterview(ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase())
            akt_interview=ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase()
            next="F001"
          } else {
            setAktInterview(interview.toLowerCase())      
            setLetzteFrage("")
          } 
          setAblaufNext(next)
          return  
        }
      }
      if (frageid===letzte_frage) {
          letztes_zeichen=letztenr.substr(letztenr.length-1,1);
          neu_zeichen=Number(letztes_zeichen);
          neu_zeichen=neu_zeichen+1;
          if (neu_zeichen>9) {abzug=2 }
          if (neu_zeichen>99) {abzug=3 }
          next=letztenr.substr(0,letztenr.length-abzug)+neu_zeichen;
          akt_interview=interview.toLowerCase()
          if (ablauf_fragen[akt_interview].fragen[next].interview) {
            letzte_frage=ablauf_fragen[akt_interview].fragen[next].letzte_frage  
            letzte_nr=next
            setLetzteFrage(letzte_frage)
            setLetzteNr(letzte_nr)
            setAktInterview(ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase())
            akt_interview=ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase()
            next="F001"
          } else {
            setAktInterview(interview.toLowerCase())      
            setLetzteFrage("")
          } 
          setAblaufNext(next)
          return      
      }
      
      if (ablauf_fragen[akt_interview].fragen[next].art==="ROUTINE ENDE") {   
        frageid=next
        letztes_zeichen=frageid.substr(frageid.length-1,1);
        if (isNaN(letztes_zeichen)===false) {
          neu_zeichen=Number(letztes_zeichen);
          neu_zeichen=neu_zeichen+1;
          
          if (neu_zeichen>9) {abzug=2 }
          if (neu_zeichen>99) {abzug=3 }
          next=frageid.substr(0,frageid.length-abzug)+neu_zeichen;
        } else {
          next=frageid+"001";   
        }
        setAblaufNext(next)
        return  
      }
      if (ablauf_fragen[akt_interview].fragen[next].art==="ROUTINE ZURÜCK") {   
          next=routinestart
          setAblaufNext(next)
          return            
      }
      if (ablauf_fragen[akt_interview].fragen[next].art==="ROUTINE ZURUECK") {   
          next=routinestart
          setAblaufNext(next)
          return            
      }
      if (ablauf_fragen[akt_interview].fragen[next].art==="ROUTINE START") {   
        frageid=next
        letztes_zeichen=frageid.substr(frageid.length-1,1);
        if (isNaN(letztes_zeichen)===false) {
          neu_zeichen=Number(letztes_zeichen);
          neu_zeichen=neu_zeichen+1;
          if (neu_zeichen>9) {abzug=2 }
          if (neu_zeichen>99) {abzug=3 }
          next=frageid.substr(0,frageid.length-abzug)+neu_zeichen;
          setRoutineStart(next); ;
        } else {
          next=frageid+"001";
          setRoutineStart(next);      
        }
        setAblaufNext(next)
        return  
      }
      if (ablauf_fragen[akt_interview].fragen[next].art==="SPRINGE ZU FRAGE") {
        var spring=ablauf_fragen[akt_interview].fragen[next].springe+"$";
        next=ablauf_fragen[akt_interview].avar[spring].frage;
              
        if (ablauf_fragen[akt_interview].fragen[next].art === "ERGEBNIS") {
          if (akt_interview!==interview.toLowerCase()) {
            letztes_zeichen=letztenr.substr(letztenr.length-1,1);
            neu_zeichen=Number(letztes_zeichen);
            neu_zeichen=neu_zeichen+1;
            if (neu_zeichen>9) {abzug=2 }
            if (neu_zeichen>99) {abzug=3 }
            next=letztenr.substr(0,letztenr.length-abzug)+neu_zeichen;
            akt_interview=interview.toLowerCase()
  
            if (ablauf_fragen[akt_interview].fragen[next].interview) {
              letzte_frage=ablauf_fragen[akt_interview].fragen[next].letzte_frage  
              letzte_nr=next
              setLetzteFrage(letzte_frage)
              setLetzteNr(letzte_nr)
              setAktInterview(ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase())
              akt_interview=ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase()
              next="F001"
            } else {
              setAktInterview(interview.toLowerCase())
              setLetzteFrage("")
            }
          }
          setAblaufNext(next)
          return  
        }
  
        if (frageid===letzte_frage) {
            letztes_zeichen=letzte_nr.substr(letzte_nr.length-1,1);
            neu_zeichen=Number(letztes_zeichen);
            neu_zeichen=neu_zeichen+1;
            if (neu_zeichen>9) {abzug=2 }
            if (neu_zeichen>99) {abzug=3 }
            next=letzte_nr.substr(0,letzte_nr.length-abzug)+neu_zeichen;
            akt_interview=interview.toLowerCase()
  
            if (ablauf_fragen[akt_interview].fragen[next].interview) {
              letzte_frage=ablauf_fragen[akt_interview].fragen[next].letzte_frage  
              letzte_nr=next
              setLetzteFrage(letzte_frage)
              setLetzteNr(letzte_nr)
              setAktInterview(ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase())
              akt_interview=ablauf_fragen[akt_interview].fragen[next].interview.toLowerCase()
              next="F001"
            } else {
              setAktInterview(interview.toLowerCase())      
              setLetzteFrage("")
            }   
        }
       // setRoutineStart(next);   
      }
      if (ablauf_fragen[akt_interview].fragen[next].art==="BEDINGUNG") {
        await bedingung(ablauf_fragen[akt_interview].fragen[next],fragenr,"BEDINGUNG",ablauf_fragen[akt_interview].fragen[next].iv);
        setAblaufNext(next+refabgang.current)
        return
      }
      // Vorbedingung abfragen
      if (ablauf_fragen[akt_interview].fragen[next].art!=="BEDINGUNG" || ablauf_fragen[akt_interview].fragen[next].art!=="SPRINGE ZU FRAGE") {
        if(workflowuebergaben) {
          var fragen_var=ablauf_fragen[akt_interview].fragen[next].var
          fragen_var=fragen_var.replace("$","")
          if (workflowuebergaben[akt_interview.toUpperCase()]?.[fragen_var]){
            temp_antwort=workflowuebergaben[akt_interview.toUpperCase()]?.[fragen_var]
          }
        }
        if (ablauf_fragen[akt_interview].fragen[next].vor==="1") {
          await bedingung(ablauf_fragen[akt_interview].fragen[next],fragenr,"VOR",ablauf_fragen[akt_interview].fragen[next].iv,);
          if (refbedingung_bez.current!=="") {
            ablauf_fragen[akt_interview].fragen[next].bez=refbedingung_bez.current;
          }
          if (refbedingung_antwort.current!=="") {
              temp_antwort=refbedingung_antwort.current;
          }
          if (refbedingung_art.current!=="") {
            ablauf_fragen[akt_interview].fragen[next].art=refbedingung_art.current;
          } 
          if (refbedingung_auswahl.current!=="") {
            ablauf_fragen[akt_interview].fragen[next].auswahl=refbedingung_auswahl.current;
          }
          if (refbedingung_iv.current!=="") {
            navigate("/interview/"+refbedingung_iv.current,
              {
              state: { programm: programm, uebergaben: uebergaben }, replace: true
            })
           
            return
          }
        }
      }
      
      if (!fehler) {
        temp_daten.push({key:next,art:ablauf_fragen[akt_interview].fragen[next].art,bez:ablauf_fragen[akt_interview].fragen[next].bez,antwort:temp_antwort,eingabeart:ablauf_fragen[akt_interview].fragen[next].eingabeart,avar:ablauf_fragen[akt_interview].fragen[next].var,auswahl:ablauf_fragen[akt_interview].fragen[next].auswahl,ausblenden:refbedingung_ausblenden.current,antwort_ueber: refbedingung_antwort_ueber.current,iv:ablauf_fragen[akt_interview].fragen[next].iv,letzte_nr:letztenr,letzte_frage:letztefrage,datei:refbedingung_datei.current,pflicht:refbedingung_pflicht.current,disabled:refbedingung_disabled.current}); 
        neuzeichnen.current=1;
        setGezeichnet(temp_daten);
      }
    }  
  }
  async function naechste_frage(fragenr,frageid,value,interv,frage_letzte_nr,frage_letzte_frage) {   
    var temp_daten=gezeichnet.slice();
    var ablauf_fragen=Object.assign(ablauf);
    var objAntwort=Object.assign(antwort)
    var akt_interview=interv;
    var next=""
   
    temp_daten[fragenr]["antwort"]=value;
    objAntwort[interv+frageid+fragenr]=value;  
    
    if (ablauf_fragen[akt_interview].fragen[frageid].nach==="1") {
      await bedingung(ablauf_fragen[akt_interview].fragen[frageid],fragenr,"nach",ablauf_fragen[akt_interview].fragen[frageid].iv,temp_daten,);
      if (refbedingung_antwort.current!=="") {
        value=refbedingung_antwort.current
        temp_daten[fragenr]["antwort"]=refbedingung_antwort.current;
        objAntwort[interv+frageid+fragenr]=refbedingung_antwort.current
      }
      if (refbedingung_fehler.current==="2") {
        return;
      }
      if (refbedingung_fehler.current==="1") {
        navigate(-1);
      }
    }
    if (ablauf_fragen[akt_interview].fragen[frageid].eingabeart==="DATUM" && !value) {
      return
    }
    temp_daten = temp_daten.slice(0, fragenr+1);
    
    if (interv!==akt_interview) {
      akt_interview=interv      
    }
    if (frage_letzte_nr) {
      var letzte_nr=frage_letzte_nr
      var letzte_frage=frage_letzte_frage
      setLetzteNr(letzte_nr)
      setLetzteFrage(letzte_frage)
    }
    
    if (ablauf_fragen[akt_interview].fragen[frageid].art==="JA-NEIN-FRAGE") { 
      next=frageid+value;
    }
    if (ablauf_fragen[akt_interview].fragen[frageid].art==="DROPBOX") {
      if (value!=="") {
        next=frageid+ablauf_fragen[akt_interview].fragen[frageid].auswahl.find((test)=>test.tbl===value).ausgang
      }
    } 
    
    if ( ablauf_fragen[akt_interview].fragen[frageid].art!=="JA-NEIN-FRAGE" && ablauf_fragen[akt_interview].fragen[frageid].art!=="DROPBOX")  {
      var letztes_zeichen=frageid.substr(frageid.length-3,3);
      if ((value!=="" || temp_daten[fragenr]?.pflicht!=="1") || gezeichnet[gezeichnet.length-1].art==="TITEL" ||  gezeichnet[gezeichnet.length-1].art==="HINWEIS" || gezeichnet[gezeichnet.length-1].ausblenden==="1") {
        if (isNaN(letztes_zeichen)===false) {
          var neu_zeichen=Number(letztes_zeichen);
          neu_zeichen=neu_zeichen+1;
          var abzug=1
          if (neu_zeichen>9) {abzug=2 }
          if (neu_zeichen>99) {abzug=3 }
          next=frageid.substr(0,frageid.length-abzug)+neu_zeichen; 
        } else {
          next=frageid+"001";
        }
      }
    }
    setAktInterview(interv);
    setGezeichnet(temp_daten);
    setAblaufNext(next);
    setAntwort(objAntwort);
    
    if (ablaufnext===next) {
      setGleicheFrage(true)
    } else {
      setGleicheFrage(false)
    }
  }
  //console.log(ablauf);
  const zeichne_frage= (element,count) => {
    
    var zu_zeichnende_frage=""
    if (element.ausblenden!=="1" || element.art==="ERGEBNIS") {
    switch (element.art) {
      case "JAHRMONAT":
        zu_zeichnende_frage=
        <Fragment>
          <Grid item xs={12} sm={6}>        
            <Typography id={element.iv+element.key} >
              {t("Zeitraum")}
            </Typography>          
          </Grid>
          <Grid item xs={12} sm={6}> 
            <Zeitraum  programm={programm} client={client} onBlur={(value) => naechste_frage(count,element.key,value,element.iv,element.letzte_nr,element.letzte_frage)}  onChange={(value)=> naechste_frage(count,element.key,value,element.iv,element.letzte_nr,element.letzte_frage)}  /> 
          </Grid>
        </Fragment>       
      break;
      case "ZEITRAUM":
        zu_zeichnende_frage=
        <Fragment>
          <Grid item xs={12} sm={6}>        
          <Typography id={element.iv+element.key} >
              {t("Zeitraum")}
            </Typography>          
          </Grid>
          <Grid item xs={12} sm={6}> 
            <Zeitraum  programm={programm} client={client} onBlur={(value) => naechste_frage(count,element.key,value,element.iv,element.letzte_nr,element.letzte_frage)} onChange={(value)=> naechste_frage(count,element.key,value,element.iv,element.letzte_nr,element.letzte_frage)}  /> 
          </Grid>
        </Fragment>
      break;
      case "MITARBEITERAUSWAHL":
        zu_zeichnende_frage=
        <Fragment>
          <Grid item xs={12} sm={6}>
          <Typography id={element.iv+element.key} >
              {t("Für welchen Mitarbeiter")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Mitarbeiterauswahl programm={programm} client={client} austritt={austritt} onChange={(value) => naechste_frage(count,element.key,value,element.iv,element.letzte_nr,element.letzte_frage)}/>
          </Grid>
        </Fragment>
      break;
      case "DROPBOX":
        zu_zeichnende_frage=        
        <Fragment>
          <Grid item xs={12} sm={6}>        
          <Typography id={element.iv+element.key} >
              {element.bez}
            </Typography>          
          </Grid>
          
          <Grid item xs={12} sm={6}> 
          <Autocomplete
            noOptionsText={t("kein Eintrag gefunden")}
            disabled={element.disabled ==="1"}
            openOnFocus
            autoHighlight
            onChange={(event, newValue) => {
            if (newValue!==null) {
              naechste_frage(count,element.key,newValue.tbl,element.iv,element.letzte_nr,element.letzte_frage);
              } else {
              naechste_frage(count,element.key,"",element.iv,element.letzte_nr,element.letzte_frage);
              }
            }}
            options={element.auswahl}
            getOptionLabel={(option) => option.zusatz ? option.vorgabe + " " + option.zusatz : option.vorgabe}
            defaultValue={
              element.auswahl.find((antwort) => antwort.tbl===element.antwort)
            }          
            disablePortal
            renderInput={(params) => 
            <TextField 
              autoFocus
              {...params} 
              variant="outlined"            
              InputLabelProps={{
                  shrink: true,
              }}                
            />
            }
          />
          </Grid>
        </Fragment>
      break;
      case "NUR AUSWAHL DROPBOX":
        zu_zeichnende_frage= 
        <Fragment>
          <Grid item xs={12} sm={6}>        
          <Typography id={element.iv+element.key} >
              {element.bez}
            </Typography>          
          </Grid>
          
          <Grid item xs={12} sm={6}> 
          <Autocomplete
            disabled={element.disabled ==="1"}
            noOptionsText={t("kein Eintrag gefunden")}
            openOnFocus
            autoHighlight
            onChange={(event, newValue) => {
            if (newValue!==null) {
              naechste_frage(count,element.key,newValue.tbl,element.iv,element.letzte_nr,element.letzte_frage);
              } else {
              naechste_frage(count,element.key,"",element.iv,element.letzte_nr,element.letzte_frage);
              }
            }}
            options={element.auswahl}
            getOptionLabel={(option) => option.zusatz ? option.vorgabe + " " + option.zusatz : option.vorgabe}
            defaultValue={
              element.auswahl.find((antwort) => antwort.tbl===element.antwort)
            }
            
            disablePortal
            renderInput={(params) => 
            <TextField
              autoFocus
              {...params} 
              variant="outlined"            
              InputLabelProps={{
                  shrink: true,
              }}                
            />
            }
          />
          </Grid>
        </Fragment>
      break;  
      case "JA-NEIN-FRAGE":
        zu_zeichnende_frage= 
        <Fragment>
            <Grid item xs={12} sm={6}>        
            <Typography id={element.iv+element.key} >
                {element.bez}
              </Typography>          
            </Grid>
          <Grid item xs={12} sm={6}> 
          <Autocomplete
          disabled={element.disabled ==="1"}
            disablePortal
            noOptionsText={t("kein Eintrag gefunden")}
            openOnFocus
            autoHighlight
            onChange={(event, newValue) => {
            if (newValue!==null) {
              naechste_frage(count,element.key,newValue.tbl,element.iv,element.letzte_nr,element.letzte_frage);
              } else {
              naechste_frage(count,element.key,"",element.iv,element.letzte_nr,element.letzte_frage);
              }
            }}
            options={janein}
            getOptionLabel={(option) => option.vorgabe || ""}
            //getOptionSelected={(option) => element.antwort!=="" ? element.antwort===option.tbl  : "J"===option.tbl} // Ist unnötig (HE)
            defaultValue={
              janein.find((antwort) => antwort.tbl===element.antwort)
            }   
            renderInput={(params) => 
            <TextField 
              autoFocus
              {...params} 
              variant="outlined"
              InputLabelProps={{
                  shrink: true,
              }}                
            />
            }
          />
          </Grid>
        </Fragment>
      break;
      case "JA-NEIN-1-ABGANG":
        zu_zeichnende_frage= 
        <Fragment>
            <Grid item xs={12} sm={6}>        
            <Typography id={element.iv+element.key} >
                {element.bez}
              </Typography>          
            </Grid>
      
            <Grid item xs={12} sm={6}> 
          <Autocomplete
          disabled={element.disabled ==="1"}
            disablePortal
            noOptionsText={t("kein Eintrag gefunden")}
            openOnFocus
            autoHighlight
            onChange={(event, newValue) => {
            if (newValue!==null) {
              naechste_frage(count,element.key,newValue.tbl,element.iv,element.letzte_nr,element.letzte_frage);
              } else {
              naechste_frage(count,element.key,"",element.iv,element.letzte_nr,element.letzte_frage);
              }
            }}
            options={janein}
            getOptionLabel={(option) => option.vorgabe || ""}
            defaultValue={
              janein.find((antwort)=> antwort.tbl===element.antwort) 
            }   
            renderInput={(params) =>   
            <TextField 
              autoFocus
              {...params} 
              variant="outlined"
               
              InputLabelProps={{
                  shrink: true,
              }}                
            />
            }
          />
          </Grid>
        </Fragment>
      break;
      case "HINWEIS":
        if (element.ausblenden!=="1") {
          zu_zeichnende_frage= 
          <Fragment>
          <Grid item xs={12}>
            <Typography variant="body1" color="textSecondary" id={element.iv+element.key} >
              {element.bez}
          </Typography>
          </Grid>
          </Fragment>
        }
      break;
      case "TITEL":
        zu_zeichnende_frage= 
        <Fragment>
        <Grid item xs={12}>
          <Typography variant="h6" color="primary" id={element.iv+element.key} > 
            {element.bez}
        </Typography>
        </Grid>
        </Fragment>      
      break;
      case "BUTTON":
        zu_zeichnende_frage= 
        <Fragment>
        <Grid item xs={12}>
          {  (element.datei==="einzel" || element.datei==="multi")  ?
            <div>
            <Grid item xs={12}>
            <input
            disabled={element.disabled ==="1"}
              multiple={element.datei==="multi"}
              color="primary"
              type="file"
              id="file-input"
              onChange={ (event) =>  onChangeHandler(event,count,element)}
              style={{display: 'none'}}
            />
            <label htmlFor="file-input" className="mr-2">
              <Button
                id="au_upload"
                variant="contained"
                component="span"
                color="primary"
                label={t("Dateiupload")}
              >
                {t("Datei auswählen")}
              </Button>
            </label> 
            </Grid>
            { selectedFile.length>0 && 
              selectedFile.map((file)=> {
              return (
                <Grid item xs={12}>
                <Typography variant="body1" color="primary">
                  {"Ausgewählte Datei: " + file.name }
                </Typography>
               </Grid>
              )
            }) } 
            </div>
           : 
            <Button 
              color="primary" 
              fullWidth
              onClick={()=>ivbutton_click(count,element)}
            >
              {element.bez}
            </Button>
          }
        </Grid> 
        </Fragment>       
      break;
      case "ERGEBNIS":
        zu_zeichnende_frage= 
        <Fragment>
          {element.ausblenden!=="1" && 
          <Grid item xs={12}>
            <Card id={element.iv+element.key} >
            <CardContent>      
              <Typography variant="body1" color="primary" align="left">
                {t("Ergebnis")}
              </Typography>
              </CardContent>
              <CardContent>      
                  {element.bez.split("\r\n").map((item)=>{
                    return(
                      <Typography variant="body2" align="left">{item}</Typography>
                    )
                  })}
              </CardContent>
            </Card>
          </Grid>
          }
          <Grid item xs={12}>  
            <Button
              autoFocus
              fullWidth
              variant="contained"
              color="primary"
              onClick={()=>interview_beenden()}
              startIcon={<SaveIcon />}
            >
            {speicherbutton}
            </Button>    
          </Grid>         
        </Fragment>
      break;
      case "EINGABE":
        zu_zeichnende_frage= 
        <Fragment>
          <Grid item xs={12} sm={6}>        
            <Typography id={element.iv+element.key} >
              {element.bez}
            </Typography>          
          </Grid>  
          <Grid item xs={12} sm={6}> 
          {
            element.eingabeart==="DATUM" ?
            <DateTextField
            disabled={element.disabled ==="1"}
                variant="outlined"
                fullWidth
                autoFocus= { 
                  (window.cordova && element.art==="date") ?  false : true 
                }
                value={ element.antwort }
                onBlur={  (event) => {if (event.relatedTarget === null) {naechste_frage(count,element.key,element.antwort,element.iv,element.letzte_nr,element.letzte_frage)}}}
                onKeyDown={
                    (taste) =>
                    { if ((taste.key==="Enter" && !element.eingabeart.match("LANG")) || (taste.key==="Enter" && taste.ctrlKey)) {
                      taste.target.blur()
                    }
                    } 
                }
                onChange={ (event) => 
                  { if (window.cordova) {
                      setze_eingabe_antwort(element.key,element.iv,event.target.value,count)
                      if (window.cordova.platformId!=="ios") {
                        naechste_frage(count,element.key,event.target.value,element.iv,element.letzte_nr,element.letzte_frage)
                      }
                    } else {
                      setze_eingabe_antwort(element.key,element.iv,event.target.value,count)
                    }
                  }
                }
            />
            :
            <TextField
            disabled={element.disabled ==="1"}
                type={ 
                  !element.eingabeart ? ""
                  : element.eingabeart.search(/ZAHLEN/i)>-1 ? "number"
                  : element.eingabeart.search(/GANZZAHLEN/i)>-1 ? "number"
                  : ""
                }
                multiline={element.eingabeart.match("LANG")}
                minRows={element.eingabeart.match("LANG") ? 4 : 1 }
                variant="outlined"
                fullWidth
                autoFocus
                value={ element.antwort }
                onBlur={  (event) => {if (event.relatedTarget === null) {naechste_frage(count,element.key,element.antwort,element.iv,element.letzte_nr,element.letzte_frage)}}}
                onKeyDown={
                    (taste) =>
                    { if ((taste.key==="Enter" && !element.eingabeart.match("LANG")) || (taste.key==="Enter" && taste.ctrlKey)) {
                      taste.target.blur()
                    }
                    } 
                }
                helperText={(element.eingabeart.match("LANG") && !window.cordova) && "Mit dem Drücken von STRG + ENTER werden Sie automatisch in die nächste Frage geleitet."}
                onChange={ (event) => 
                  { if (window.cordova && element.eingabeart==="DATUM") {
                      setze_eingabe_antwort(element.key,element.iv,event.target.value,count)
                      if (window.cordova.platformId!=="ios") {
                        naechste_frage(count,element.key,event.target.value,element.iv,element.letzte_nr,element.letzte_frage)
                      }
                    } else {
                      setze_eingabe_antwort(element.key,element.iv,event.target.value,count)
                    }
                  }
                }
                inputProps={{
                  autoCapitalize: 'off',
                  autoCorrect: 'off',
                  spellCheck: 'false',
                  autoComplete: 'disabled',
                  min: '0',
                  max: '100',                 
                }}
                InputProps={{
                  min: '0',
                  max: '100',                 
                }}
                InputLabelProps={{
                    shrink: true,
                }}
            >
            </TextField>
            }     
          </Grid>
        </Fragment>
      break;
      default:                                                                                                                                                                                                                                                                                                                                                                                                                                                        
        zu_zeichnende_frage=
        <Fragment>
        <Typography>
          {"nicht Entwickelt: " +element.art}
        </Typography>
        </Fragment>
      break;
    }   
      return(zu_zeichnende_frage)
    }
  return("")
  }
  const interview_zeichnen = (gezeichnet.length>0) && gezeichnet.map((element, count) => {
    if (element.ausblenden!=="1" || element.art==="ERGEBNIS") {
      return(
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
          <Box p={1}>
          <Grid container justifyContent="flex-start" alignItems="center" >
          { zeichne_frage(element,count)}
          </Grid>
          </Box>
          </Grid>
        </Grid>
      )         
    } else {
      return(
        <div></div>
      )         
    }
  }) 
  return(
      <>
      <Typography variant="h4" color="primary" align="center">
        {interviewbez}
      </Typography>
      {interview_zeichnen}
      { fehler &&
        <Grid container justifyContent="center">
          <Grid item>
          <Button onClick={()=> erneut("")}>{t("erneut versuchen")}</Button>
          </Grid>
        </Grid>
      }
      <Box pt={window.cordova ? (mobilheight.current-128)+"px": desktopheight.current+"px" } ></Box>
    
      {showModal && <FullPageSpinner/>}
    
      </>
      
  )
}
export default Interview;
